import { object, number, array, string } from '@gogame/schemas';

import {
  ID,
  NAME,
  DESCRIPTION,
  CONCEPTS,
  ORIGINAL_CONCEPT,
} from 'scenes/Gallery/GalleryPage/ConceptFamilies/constants';

export const createValidationSchema = object({
  [ID]: number(),
  [NAME]: string().required('Name is required'),
  [DESCRIPTION]: string(),
  [CONCEPTS]: array(number()),
  [ORIGINAL_CONCEPT]: number(),
});

export const editValidationSchema = object({
  [ID]: number(),
  [NAME]: string().required('Name is required'),
  [DESCRIPTION]: string(),
  [CONCEPTS]: array(number()).required('Concepts is required'),
  [ORIGINAL_CONCEPT]: number().required('Thumbnail is required'),
});
